import React from "react";
import { CreditCard, Layers } from "lucide-react";

import { agruparOutros, DonutGrafico, DonutLegenda } from "@/components/charts/Donut";

import { formatCurrency, formatInt } from "../lib/formato";

function CardDonut({ titulo, icone: Icone, onVerDetalhes, children, e2e }) {
  return (
    <div className="bg-card rounded-xl border p-6" data-e2e={e2e}>
      <button type="button" onClick={onVerDetalhes} title={`Abrir ${titulo}`}
        className="w-full flex items-center gap-2 mb-4 text-left hover:text-primary transition-colors">
        <Icone className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-bold">{titulo}</h2>
        <span className="text-xs text-muted-foreground ml-auto">Ver detalhes →</span>
      </button>
      {children}
    </div>
  );
}

const pedidosEValor = (item) => (
  <span className="flex flex-col items-end leading-tight">
    <span>{formatInt(item.quantidade)} pedido(s)</span>
    <span className="text-[10px] text-muted-foreground font-normal">{formatCurrency(item.valor_total)}</span>
  </span>
);

// Pagamentos (por valor) e Módulos (por pedidos), com as mesmas regras de donut
// da Visão Geral — pedido do dono em 21/09/2026.
export default function DonutsResumo({ formasPagamento, modulos, onVerDetalhes }) {
  const pagamentos = agruparOutros(formasPagamento, "valor");
  const canais = agruparOutros(modulos, "quantidade", 10, ["valor_total"]);
  if (!pagamentos.length && !canais.length) return null;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {pagamentos.length > 0 && (
        <CardDonut titulo="Pagamentos" icone={CreditCard} onVerDetalhes={() => onVerDetalhes("pagamentos")} e2e="donut-pagamentos">
          <DonutGrafico data={pagamentos} dataKey="valor" formatVal={(v) => formatCurrency(v)} />
          <DonutLegenda data={pagamentos} dataKey="valor" valueLabel={(item) => formatCurrency(item.valor)} />
        </CardDonut>
      )}
      {canais.length > 0 && (
        <CardDonut titulo="Por Módulo" icone={Layers} onVerDetalhes={() => onVerDetalhes("modulos")} e2e="donut-modulos">
          <DonutGrafico data={canais} dataKey="quantidade" formatVal={(v) => `${formatInt(v)} pedido(s)`} />
          <DonutLegenda data={canais} dataKey="quantidade" valueLabel={pedidosEValor} />
        </CardDonut>
      )}
    </div>
  );
}
